import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment OnboardingSlackStep_org on Org {
      id
      experiments
      slackAccountsErrorable {
        __typename
        ... on SlackAccountList {
          list {
            id
            slackTeamId
            slackUserId
            teamDisplayName
            needsUpdate
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
      slackSettingsErrorable {
        __typename
        ... on SlackSettingsList {
          list {
            id
            slackTeamId
            slackUserId
            calendarStatus {
              calendarStatusEnabled
              includeMeetingCategory
              includeMeetingTitle
            }
            dailyDigestSettings {
              enabled
              timeSlot
            }
            dndSettings {
              focusTime
              meeting
            }
            notificationSettings {
              defragSummary
            }
            # deprecated but needed for input object
            calendarStatusEnabled
            includeMeetingCategory
            includeMeetingTitle
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};

export const query = graphql`
  query OnboardingSlackStepQuery($orgRelayId: ID!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...OnboardingSlackStep_org
      }
    }
  }
`;
